module.exports = __webpack_public_path__ + "static/media/15-speaker_profile.621a69cd.webp";